import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ConfigService} from '@services/infra/config.service';
import {ImageResource} from '@services/resource/image-resource';
import {ErrorService} from '@services/error.service';
import {timeout} from 'rxjs/operators';
import {ClientConfig} from '@app/client-config';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService {
  constructor(
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
    private readonly errors: ErrorService,
  ) {}

  public uploadImage(productId: string, image: File | Blob, imageResource: ImageResource): Observable<ImageResource> {
    console.log(imageResource);
    const url = `${this.conf.backendUrl}/v1/images/${productId}`;
    // TODO: Refactor the endpoint so that we don't need to wrap the imageType into this piece
    return this.upload(url, image, imageResource);
  }

  public uploadStartUpImage(startupId: string, image: File | Blob, imageResource: ImageResource): Observable<ImageResource> {
    const url = `${this.conf.backendUrl}/v1/images/startup/${startupId}`;

    return this.upload(url, image, imageResource);
  }

  private upload(url: string, image: File | Blob, imageResource: ImageResource): Observable<ImageResource> {
    const body = new FormData();
    body.append('file', image);
    body.append('adjustment', new Blob([JSON.stringify(imageResource)], {type: 'application/json'}));
    return this.http.post<ImageResource>(url, body).pipe(timeout(ClientConfig.uploadTimeout), this.errors.withErrorHandler());
  }
}
